import { render } from "./CuponesParaTi.vue?vue&type=template&id=e4cab708&scoped=true"
import script from "./CuponesParaTi.vue?vue&type=script&lang=js"
export * from "./CuponesParaTi.vue?vue&type=script&lang=js"

import "./CuponesParaTi.vue?vue&type=style&index=0&id=e4cab708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cab708"]])

export default __exports__